/* eslint-disable import/no-anonymous-default-export */
import MemberAttendanceReportActionTypes from './member-attendance-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getMemberAttendanceReportListResponse: null,
	getMemberAttendanceReportListArr: [],

	getMemberAttendanceReportExcelResponse: null,
	getMemberAttendanceReportExcelArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET MEMBER ATTENDANCE REPORT START *********************** */
		case MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_SUCCESS:
			return {
				...state,
				getMemberAttendanceReportListResponse: action.payload,
				getMemberAttendanceReportListArr: docodeHexResponse(
					action.payload,
					'GetMemberAttendanceReportKey',
				),
			};

		case MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_FAILURE:
			return { ...state, getMemberAttendanceReportListResponse: action.payload };

		case MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getMemberAttendanceReportListResponse: null };

		/** ***************** GET MEMBER ATTENDANCE REPORT END *********************** */

		/** ***************** FETCH MEMBER ATTENDANCE REPORT EXCEL DETAILS START *********************** */
		case MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_SUCCESS:
			return {
				...state,
				getMemberAttendanceReportExcelResponse: action.payload,
				getMemberAttendanceReportExcelArr: docodeHexResponse(
					action.payload,
					'MemberAttendanceReportExport',
				),
			};

		case MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_FAILURE:
			return { ...state, getMemberAttendanceReportExcelResponse: action.payload };

		case MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_CHANGED:
			return { ...state, getMemberAttendanceReportExcelResponse: null };

		/** ***************** FETCH MEMBER ATTENDANCE REPORT EXCEL DETAILS END *********************** */

		default:
			return state;
	}
};
